// © Microsoft Corporation. All rights reserved.

/**
 * Time To Functional
 */
export const timeToFunctional = "TTF";

/**
 * Time To Page Visible
 */
export const timeToPageVisible = "TTPV";

/**
 * Time To Visually Ready
 */
export const timeToVisuallyReady = "TTVR";

/**
 * Time To Video Start
 */
export const timeToVideoStart = "TTVS";

/**
 * pageTiming cacheKey for html cached state
 */
export const htmlCachedKey = "htmlCached";

/**
 * Page reveal start performance marker
 */
export const pageRevealStartMarker = "pageRevealStart";

/**
 * Page reveal complete performance marker
 */
export const pageRevealCompleteMarker = "pageRevealComplete";
